import { render } from "./IconHeading3.vue?vue&type=template&id=458f72b8&ts=true"
import script from "./IconHeading3.vue?vue&type=script&lang=ts"
export * from "./IconHeading3.vue?vue&type=script&lang=ts"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__